import axios from "axios";
import ConstantList from "app/appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/referral-request";

export const getAllInpatient = () => axios.get(API_PATH + "/get-all-referral-request");

export const pagingInpatient = (searchObject) => axios.post(API_PATH + "/search-referral-request-by-page", searchObject);

export const getInpatientById = (inPatientId) => axios.get(API_PATH + "/get-by-id/" + inPatientId);

export const saveInpatient = inPatient => axios.post(API_PATH + '/save', inPatient);

export const deleteInpatient = inPatientId => axios.delete(API_PATH + '/mark-delete/' + inPatientId)

export const saveReceivingPatient = (searchObject) => axios.post(API_PATH + "/receiving-patient", searchObject);

export const pagingWaitingPatient = (searchObject) => axios.post(API_PATH + "/search-waiting-patient-by-page", searchObject);

export const pagingTreatingPatient = (searchObject) => axios.post(API_PATH + "/search-treating-patient-by-page", searchObject);

export const pagingMovedPatient = (searchObject) => axios.post(API_PATH + "/search-moved-patient-by-page", searchObject);

export const pagingInPatients = (object) => axios.post(API_PATH + "/paging-in-patient", object)

export const generalReceivingPatient = (dto) => axios.post(API_PATH + "/general-receiving-patient", dto);

export const saveDischargeHospital = (dto) => axios.post(API_PATH + "/discharge-hospital", dto)